/**
 * @copyright 2026 @ DigiNet
 * @author YENNHI
 * @create 2026/06/10 09:35
 */

import * as types from '../actions/types.js';
import Config from '../config/index.js';

const initialState = {
    dataGrid: [],
    decimalScaleColumn: [],
    dataCboInventory: []
};

export default function (state = initialState, action = { }) {
    switch (action.type) {
        case types.W05_W05F2040_DATAGRID_COMPLETE:
            return {
                ...state,
                dataGrid: action.dataGrid
            };
        case types.W05_W05F2040_CBO_INVENTORY_COMPLETE:
            let dataCboInventory = [];
            if (!Config.isEmpty(action.data)) {
                dataCboInventory = action.data.map(item => {
                    const line = !Config.isEmpty(item.InventoryName) ? "-" : "";
                    return ({ ...item, value: item.InventoryID, customNameID: `${item.InventoryID} ${line} ${item.InventoryName}` })
                });
            }
            return { ...state, dataCboInventory };
        case types.W05_W05F2040_DECIMAL_COMPLETE:
            return { ...state, decimalScaleColumn: action.data };
        case types.W05_W05F2040_NUMVALUE_COMPLETE:
            return {
                ...state,
                numValue: action.numValue
            };
        default:
            return state;
    }
}
